import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-failed-payment',
  templateUrl: './popup-failed-payment.component.html',
  styleUrls: ['./popup-failed-payment.component.scss']
})
export class PopupFailedPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
